import {IDS} from "./accreditation-action-id.constants";
import {TAB_DISABLE, TAB_HIDE} from "../../common/tabs/tabs.constants";

const QUERY_PARAMS = '?itemCode&requirement&year&slo&token';

export const mainState = {
    name: 'app.accreditation',
    abstract: true,
    url: '/accreditation'
};

export const dashboardState = {
    name: 'app.accreditation.dashboard',
    url: '',
    component: 'dashboard'
};

export const abstractState = {
    name: 'app.accreditation.scheme',
    abstract: true,
    url: '/scheme'
};

export const schemeDashboardState = {
    name: 'app.accreditation.scheme.dashboard',
    url: '/:itemCode',
    component: 'dashboard',
};

export const addRegulatoryFrameworkState = {
    name: 'app.accreditation.add-scheme',
    url: '/add-scheme',
    component: IDS.addRegulatoryFramework,
};

// TODO: Remove public states

export const publicState = {
    name: 'public.accreditation',
    abstract: true,
    redirectTo: 'public.accreditation.dashboard',
    url: '/public/accreditation'
};

export const publicDashboardState = {
    name: 'public.accreditation.dashboard',
    component: 'dashboard',
    url: '/public/accreditation/dashboard'
};
